import { AnyAction } from "redux"
import {
  API_MAPPING_CALL,
  API_MAPPING_FAILURE,
  API_MAPPING_SUCCESS,
  API_MAPPING_FORM_CALL,
  API_MAPPING_FORM_FAILURE,
  API_MAPPING_FORM_SUCCESS,
  API_MAPPING_MODAL_OPEN,
  API_MAPPING_MODAL_CLOSE
} from "./api-mapping-actions"

export interface apiMappingState {
  apiMappingList: {
    data: App.ApiMapping[]
    loading: boolean
    error: string
  }
  apiMappingForm: {
    data: App.ApiMappingFormSchema
    loading: boolean
    error: string
  }
  modal: {
    type: "delete" | ""
    state: boolean
  }
}

const INITIAL_STATE: apiMappingState = {
  apiMappingList: {
    data: [] as App.ApiMapping[],
    loading: false,
    error: ""
  },
  apiMappingForm: {
    data: {
      formSchema: {},
      uiSchema: {},
      formData: {}
    } as App.ApiMappingFormSchema,
    loading: false,
    error: ""
  },
  modal: {
    type: "",
    state: false
  }
}

export default function apiMappingReducer(state: apiMappingState = INITIAL_STATE, action: AnyAction): apiMappingState {
  switch (action.type) {
    case API_MAPPING_MODAL_OPEN:
      return {
        ...state,
        modal: {
          type: action.payload.type,
          state: true
        }
      }

    case API_MAPPING_MODAL_CLOSE:
      return {
        ...state,
        modal: {
          type: "",
          state: false
        }
      }
    case API_MAPPING_CALL:
      return {
        ...state,
        apiMappingList: {
          ...state.apiMappingList,
          loading: true
        }
      }

    case API_MAPPING_SUCCESS:
      return {
        ...state,
        apiMappingList: {
          data: action.payload as App.ApiMapping[],
          loading: false,
          error: ""
        }
      }

    case API_MAPPING_FAILURE:
      return {
        ...state,
        apiMappingList: {
          ...state.apiMappingList,
          loading: false,
          error: action.payload as string
        }
      }

    case API_MAPPING_FORM_CALL:
      return {
        ...state,
        apiMappingForm: {
          ...state.apiMappingForm,
          loading: true
        }
      }

    case API_MAPPING_FORM_SUCCESS:
      return {
        ...state,
        apiMappingForm: {
          data: action.payload as App.ApiMappingFormSchema,
          loading: false,
          error: ""
        }
      }

    case API_MAPPING_FORM_FAILURE:
      return {
        ...state,
        apiMappingForm: {
          ...state.apiMappingForm,
          loading: false,
          error: action.payload as string
        }
      }

    default:
      return state
  }
}
